module.exports = __webpack_public_path__ + "static/media/step3.8591cdd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/step3.jpg
// module id = 771
// module chunks = 0